import { useCallback, useEffect, useState } from "react";
import axios from "axios";

const API_BASE = process.env.REACT_APP_BACKEND_URL || "";

function normalizeAxiosError(e) {
    return e?.response?.data?.error || e?.message || "Unbekannter Fehler";
}

export default function useRestaurantPrices() {
    const [restaurantPrices, setRestaurantPrices] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const fetchRestaurantPrices = useCallback(async () => {
        setLoading(true);
        setError("");
        try {
            const res = await axios.get(`${API_BASE}/api/restaurant-prices`, { withCredentials: true });
            const data = res.data?.restaurant_prices ?? res.data ?? [];
            setRestaurantPrices(Array.isArray(data) ? data : []);
        } catch (e) {
            setError(normalizeAxiosError(e));
        } finally {
            setLoading(false);
        }
    }, []);

    const createRestaurantPrice = useCallback(async (payload) => {
        try {
            const res = await axios.post(`${API_BASE}/api/restaurant-prices`, payload, { withCredentials: true });
            await fetchRestaurantPrices();
            return res.data?.restaurant_price;
        } catch (e) {
            throw new Error(normalizeAxiosError(e));
        }
    }, [fetchRestaurantPrices]);

    const updateRestaurantPrice = useCallback(async (id, payload) => {
        try {
            const res = await axios.put(`${API_BASE}/api/restaurant-prices/${id}`, payload, { withCredentials: true });
            await fetchRestaurantPrices();
            return res.data?.restaurant_price;
        } catch (e) {
            throw new Error(normalizeAxiosError(e));
        }
    }, [fetchRestaurantPrices]);

    const deleteRestaurantPrice = useCallback(async (id) => {
        try {
            await axios.delete(`${API_BASE}/api/restaurant-prices/${id}`, { withCredentials: true });
            await fetchRestaurantPrices();
        } catch (e) {
            throw new Error(normalizeAxiosError(e));
        }
    }, [fetchRestaurantPrices]);

    useEffect(() => {
        fetchRestaurantPrices();
    }, [fetchRestaurantPrices]);

    return {
        restaurantPrices,
        loading,
        error,
        fetchRestaurantPrices,
        createRestaurantPrice,
        updateRestaurantPrice,
        deleteRestaurantPrice,
    };
}
